(function () {
  Motion.file('errors/message.js', function (require) {
    var _helpers = require('./helpers');

    var last = function last(arr) {
      return arr[arr.length - 1];
    };
    var fileName = function fileName(url) {
      return url && url.replace(/[\?\)].*/, '');
    };
    var getLine = function getLine(err) {
      return err && (err.line || err.loc && err.loc.line);
    };

    Motion.staticStyles('Errors.Message', {
      '$bar': '#_motiondevtools bar.Errors-Message, #_motiondevtools .Errors-Message.bar, #_motiondevtools .ViewErrors-Message.bar',
      '$inner': '#_motiondevtools inner.Errors-Message, #_motiondevtools .Errors-Message.inner, #_motiondevtools .ViewErrors-Message.inner',
      '$top': '#_motiondevtools top.Errors-Message, #_motiondevtools .Errors-Message.top, #_motiondevtools .ViewErrors-Message.top',
      '$where': '#_motiondevtools where.Errors-Message, #_motiondevtools .Errors-Message.where, #_motiondevtools .ViewErrors-Message.where',
      '$line': '#_motiondevtools line.Errors-Message, #_motiondevtools .Errors-Message.line, #_motiondevtools .ViewErrors-Message.line',
      '$motion': '#_motiondevtools motion.Errors-Message, #_motiondevtools .Errors-Message.motion, #_motiondevtools .ViewErrors-Message.motion',
      '$shortError': '#_motiondevtools shortError.Errors-Message, #_motiondevtools .Errors-Message.shortError, #_motiondevtools .ViewErrors-Message.shortError',
      '$cur': '#_motiondevtools cur.Errors-Message, #_motiondevtools .Errors-Message.cur, #_motiondevtools .ViewErrors-Message.cur',
      '$errCol': '#_motiondevtools errCol.Errors-Message, #_motiondevtools .Errors-Message.errCol, #_motiondevtools .ViewErrors-Message.errCol',
      '$ln': '#_motiondevtools ln.Errors-Message, #_motiondevtools .Errors-Message.ln, #_motiondevtools .ViewErrors-Message.ln',
      '$motionline': '#_motiondevtools motionline.Errors-Message, #_motiondevtools .Errors-Message.motionline, #_motiondevtools .ViewErrors-Message.motionline'
    }, {
      '$bar': {
        display: 'block',

        position: 'fixed',
        left: 0,

        transition: 'all 200ms ease-in',
        right: 0,
        fontFamily: '-apple-system, "San Francisco", Roboto, "Segou UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontWeight: 300,
        color: '#fff',
        fontSize: '14px',
        padding: 2,
        pointerEvents: 'all',
        overflow: 'hidden',
        zIndex: 2147483647,
        boxShadow: '0 -6px 12px rgba(0,0,0,0.06)'
      },
      '$inner': {
        display: 'block',
        maxHeight: 200,
        overflowY: 'scroll'
      },
      '$top': {
        padding: 8,
        display: 'block'
      },
      '$where': {
        display: 'inline-block',
        pointerEvents: 'all',
        fontWeight: 300,
        color: 'rgba(255,255,255,0.8)'
      },
      '$line': {
        display: 'inline-block',
        whiteSpace: 'pre',
        pointerEvents: 'all'
      },
      '$motion': {
        display: 'inline',
        fontWeight: 700,
        color: '#fff'
      },
      '$shortError': {
        display: 'inline',
        color: 'rgba(255,255,255,0.7)'
      },
      '$cur': {
        background: '#fff'
      },
      '$errCol': {
        display: 'inline',
        borderBottom: '2px solid #f5d64c',
        margin: -3,
        padding: 3,
        color: '#fff'
      },
      '$ln': {
        padding: [0, 20]
      },
      '$motionline': {
        whiteSpace: 'pre',
        pointerEvents: 'all',
        fontWeight: 'motion'
      }
    });
    Motion.view('Errors.Message', function (view, on, $) {
      var hasError = false;
      var error = {};
      var npmError = undefined,
          fullStack = undefined;
      var line = getLine(view.props.error);
      var clearDelay = undefined;

      on.props(function () {
        clearDelay && clearDelay();

        view.set('npmError', npmError = view.props.npmError);
        view.set('hasError', hasError = !!(view.props.error || view.props.npmError));
        view.set('error', error = view.props.error || error); // keep old
        view.set('line', line = getLine(error));
        view.set('fullStack', fullStack = null);

        // show full stack after a delay
        if (error) {
          view.set('clearDelay', clearDelay = on.delay(2500, function () {
            if (hasError && error.fullStack) {
              view.set('fullStack', fullStack = error.fullStack);
            }
            view.updateSoft();
          }));
        }
        view.updateSoft();
      });

      // update on editor state
      _helpers.browser.emitter.on('editor:state', function () {
        return setTimeout(view.update);
      });view.render(function () {
        return view.el(
          ['Debounce', 1],
          {
            // delay more during live typing
            delay: (0, _helpers.isLive)() ? 2000 : 1000,
            force: hasError === false,
            showKey: error && error.timestamp || fullStack,
            onUpdate: _helpers.showMotionErrorDiv
          },
          view.el(
            ['bar', 1],
            null,
            view.el(['Close', 1], { onClick: view.props.close, size: 35 }),
            Motion.iff(npmError) && view.el(
              ['inner', 1],
              { if: npmError },
              view.el(
                ['where', 1],
                null,
                view.el(
                  ['motion', 1],
                  null,
                  npmError.name
                )
              ),
              ' ',
              npmError.msg
            ),
            view.el(
              ['inner', 2],
              null,
              view.el(
                ['top', 1],
                null,
                view.el(
                  ['where', 2],
                  null,
                  view.el(
                    ['span', 1],
                    null,
                    'In ',
                    view.el(
                      ['motion', 2],
                      null,
                      fileName(error.file)
                    )
                  ),
                  view.el(
                    ['line', 1],
                    null,
                    line ? ' line' : '',
                    ' ',
                    Motion.iff(line) && view.el(
                      ['motion', 3],
                      { if: line },
                      line
                    )
                  )
                ),
                ' ',
                view.el(
                  ['shortError', 1],
                  null,
                  (error.niceMessage || error.message || '').trim(),
                  Motion.iff(error.niceStack) && view.el(
                    ['niceStack', 1],
                    { if: error.niceStack },
                    error.niceStack[0],
                    view.el(
                      ['errCol', 1],
                      null,
                      error.niceStack[1]
                    ),
                    error.niceStack[2]
                  )
                ),
                Motion.iff(error.help) && view.el(
                  ['help', 1],
                  { if: error.help },
                  error.help
                )
              ),
              Motion.iff(fullStack) && view.el(
                ['fullStack', 1],
                { if: fullStack },
                view.el(
                  ['ln', 1],
                  null,
                  '' + fullStack[0]
                ),
                view.el(
                  ['ln', 2],
                  { className: 'cur' },
                  '' + fullStack[1]
                ),
                view.el(
                  ['ln', 3],
                  null,
                  '' + fullStack[2]
                )
              )
            )
          )
        );
      });

      var red = '#cd423e';

      $["bar"] = function (_, _index) {
        return { background: red, bottom: hasError ? 0 : -100 };
      };

      var stack = {
        color: 'rgba(255,255,255,0.85)',
        display: 'inline',
        fontFamily: 'Meslo, Menlo, Monaco, monospace',
        padding: [0, 5]
      };

      $["niceStack"] = function (_, _index) {
        return stack;
      };

      $["fullStack"] = function (_, _index) {
        return [stack, {
          maxHeight: fullStack ? 600 : 0,
          padding: fullStack ? [10, 0] : 0,
          transition: 'maxHeight ease-in 300ms',
          color: 'rgba(0,0,0,0.85)',
          background: 'rgba(255,255,255,0.9)',
          display: 'block',
          whiteSpace: 'pre',
          fontSize: 14,
          borderRadius: 3,
          margin: 2
        }];
      };
    });
  })
})();
//# sourceMappingURL=message.js.map
